/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import {lazy, Suspense, useContext, useEffect, useMemo, useState} from 'react'

import Context from '@s-ui/react-context'
import {MoleculeAccordionItem} from '@s-ui/react-molecule-accordion'
import {
  FilterBasicLegacySingleSelectionItem,
  filterBasicLegacySingleSelectionItemDesigns
} from '@adv-mt/mt-filter-basic-legacy'
import {mostSearchedMakes} from '@adv-mt/mt-shared-make-logos'

import {NO_OP, WRAPPER_CLASS_NAME} from '../../../config.js'

const LazyModelList = lazy(() => import(/* webpackChunkName: "LazyModelList" */ '../ModelList/index.js'))

const MakeAccordion = ({isOpen, make, makeTotalResults, onChange, value}) => {
  const [showContent, setShowContent] = useState(isOpen)
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {DEFAULT_MODEL} = config.get('search')

  const selectedModelsIds = useMemo(() => value.map(({model}) => model && String(model.id)).filter(Boolean), [value])

  const label = useMemo(() => {
    const [firstSelection] = value
    const areAllOptionsSelected = String(firstSelection?.model?.id) === String(DEFAULT_MODEL.id)
    if (areAllOptionsSelected) return `${make.label} (${i18n.t('COMMON.ALL')})`
    if (value.length) return `${make.label} (${value.length})`
    return make.label
  }, [value])

  useEffect(() => {
    setShowContent(isOpen)
  }, [isOpen])

  return (
    <div className={`${WRAPPER_CLASS_NAME}Option`}>
      <MoleculeAccordionItem
        content={
          <Suspense fallback={<></>}>
            {showContent ? <LazyModelList make={make} onChange={onChange} value={selectedModelsIds} /> : <></>}
          </Suspense>
        }
        headerAs="h3"
        label={
          <FilterBasicLegacySingleSelectionItem
            design={filterBasicLegacySingleSelectionItemDesigns.COMPRESSED}
            extendedInfo={i18n.n(makeTotalResults)}
            icon={mostSearchedMakes[make.id]?.icon}
            id={make.id}
            label={label}
            onChange={NO_OP}
          />
        }
        value={String(make.id)}
      />
    </div>
  )
}

export default MakeAccordion
